import {Project} from '../types/projects';

export interface ProjectAccess {
  /** super-admin y org-admin ven todos los proyectos de la organización. */
  isOrganizationWide: boolean;
  /** Proyectos asignados en el token; solo cuenta para quien no ve toda la organización. */
  allowedProjectIds: string[];
}

/**
 * Regla única de qué proyectos puede elegir un usuario: solo activos y, salvo
 * para quien ve toda la organización, solo los que tiene asignados. Los ids se
 * comparan sin distinguir mayúsculas porque el token y directory no siempre
 * coinciden en el casing.
 *
 * @param projects proyectos de la organización tal como los devuelve directory
 * @param access alcance del usuario logueado
 * @returns proyectos que el usuario puede seleccionar
 */
export function filterAccessibleProjects(
  projects: Project[],
  access: ProjectAccess,
): Project[] {
  const enabled = projects.filter(project => project.enabled);
  if (access.isOrganizationWide) {
    return enabled;
  }
  const allowed = new Set(access.allowedProjectIds.map(id => id.toUpperCase()));
  return enabled.filter(
    project => !!project.idProject && allowed.has(project.idProject.toUpperCase()),
  );
}
